module.exports = __webpack_public_path__ + "static/media/twitter.9f1170a3.svg";